    
    import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import React, { useState,useEffect} from 'react';
    import IconButton from '@mui/material/IconButton';
    import CloseIcon from '@mui/icons-material/Close';
     
    import {  useNavigate} from 'react-router-dom';
    import { DataGrid, GridToolbar } from '@mui/x-data-grid';

    export default function ProductDialog({children,dialogopen,dialogclose, title = null, subtitle=null, handleAction = null}) {
        

        useEffect(() => {
            //alert(productopen)
            if(dialogopen) {
                dialogclose(true);
              
            }
          
        }, [dialogopen]);

        const handleClose = () => {
            dialogclose(false)
            if(handleAction){
                handleAction();
            }
        }

        return( 
            <Dialog
                open={dialogopen}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
            >
                <form  role="form"> 
                <DialogTitle>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <DialogContentText>
                        {subtitle}
                    </DialogContentText>
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                            {children}
                        </div>
                    </div>
                </DialogContent>
                {/* <DialogActions>
                    <button className='btn' onClick={handleClose} type='button'>Close</button>
                </DialogActions> */}
                </form>
                </Dialog>
        )
    }
    
    